import React from "react";
import PropTypes from "prop-types";
import styles from "./CommonCheckboxSimNao.module.css";

/**
 * Checkbox reutilizável para valores true ou false que exibe "SIM" e "NÃO"
 */
function CommonCheckboxSimNao({
  label,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  dataOnLabel = "SIM",
  dataOffLabel = "NÃO",
  ...props
}) {
  return (
    <div>
      {label && (
        <>
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <div>
        <label
          className={`${styles.switch} ${styles[`switch-${String(value || false)}`]} ${disabled && styles.disabled}`}
          onClick={() => {
            document.getElementById(id).click();
          }}
          data-on-label={dataOnLabel}
          data-off-label={dataOffLabel}
        ></label>
        <input
          style={{ display: "none" }}
          type="checkbox"
          id={id}
          name={id}
          disabled={disabled}
          checked={value}
          onChange={disabled ? null : onChange}
          {...props}
        />
      </div>
    </div>
  );
}

CommonCheckboxSimNao.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  dataOnLabel: PropTypes.string,
  dataOffLabel: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CommonCheckboxSimNao;
